module.exports = __webpack_public_path__ + "static/media/close.ef9539f6.svg";